import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useProperty } from "@/contexts/PropertyContext";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminArcPage() {
  const { propertyId } = useProperty();
  const [items, setItems] = useState([]);
  const load = async () => {
    const { data } = await api.get(`/arc?property_id=${propertyId}`);
    setItems(data.items);
  };
  useEffect(() => { if (propertyId) load(); }, [propertyId]);

  const decide = async (id, decision) => {
    await api.patch(`/arc/${id}/decide`, { decision });
    toast.success("Recorded");
    load();
  };

  return (
    <div>
      <PageHeader eyebrow="Committee" title="ARC Requests" subtitle="Architectural Review Committee — pending & decisions." />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((a) => (
          <Card key={a.id} className="border-white/10 bg-card p-5" data-testid={`arc-card-${a.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="overline">{a.category}</div>
                <div className="text-lg font-semibold font-display mt-1">{a.title}</div>
                <div className="text-xs text-zinc-500 mt-1">{a.resident_name} · Unit {a.unit}</div>
              </div>
              <Badge variant="outline" className="border-white/10 capitalize">{a.status.replace("_"," ")}</Badge>
            </div>
            <p className="text-sm text-zinc-300 mt-3">{a.description}</p>
            {(a.status === "submitted" || a.status === "in_review") && (
              <div className="mt-4 flex gap-2">
                <Button size="sm" onClick={() => decide(a.id, "approved")} data-testid={`arc-approve-${a.id}`} className="bg-emerald-600 hover:bg-emerald-700">Approve</Button>
                <Button size="sm" variant="outline" onClick={() => decide(a.id, "more_info")} className="border-white/10">Request info</Button>
                <Button size="sm" variant="outline" onClick={() => decide(a.id, "denied")} className="border-rose-500/40 text-rose-300">Deny</Button>
              </div>
            )}
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground">No requests.</div>}
      </div>
    </div>
  );
}
